import {useQuery} from "react-query";
import axios from "axios";

const apiUrl = "api/audit/command-history/by-status";

export interface CommandCountByStatus {
    success: boolean;
    count: number;
}

const fetchCommandCountByStatus = async (
    startDateTime: string | null,
    endDateTime: string | null,
    powerStationIds?: number[] | null
): Promise<CommandCountByStatus[]> => {
    try {
        const params = new URLSearchParams();
        if (startDateTime) params.append("startDateTime", startDateTime);
        if (endDateTime) params.append("endDateTime", endDateTime);
        if (powerStationIds && powerStationIds.length > 0) {
            powerStationIds.forEach((id) => params.append("powerStationIds", String(id)));
        }
        const response = await axios.get(apiUrl, {params, timeout: 30000});
        return response.data ?? [];
    } catch (error) {
        console.error("Error fetching command count by status:", error);
        return [];
    }
};

export const CommandCountByStatusReactQuery = (
    startDateTime: string | null,
    endDateTime: string | null,
    enabled: boolean = true,
    powerStationIds?: number[] | null
) => {
    return useQuery({
        queryKey: ["command-count-by-status", startDateTime, endDateTime, powerStationIds],
        queryFn: () => fetchCommandCountByStatus(startDateTime, endDateTime, powerStationIds),
        enabled: enabled && !!startDateTime && !!endDateTime,
    });
};
